export const ADDITIVES = 1;
export const BINDERS = 2;
export const FILLERS = 3;
export const PIGMENTS = 4;
export const PERSONALCARE = 5;